<template>
<div class="panel">
<span class="font-weight-black body-2 white--text">ACCESO A CONSULTA </span><br />
<router-link to="/diario"> <img src="/static/diario.png" width="100%" alt="DiarioOficial" /></router-link>
    
</div>
</template>

<script>


export default {
 

    components: {},
    text: "dOficial",

    
};
</script>

<style scoped>
.panel {
    margin-left: 20px;
    margin-right: 10px;
}
</style>
